export enum MARITAL_STATUS {
	MARRIED = "MARRIED",
	SINGLE = "SINGLE",
	DIVORCED = "DIVORCED",
	PARTNER = "PARTNER",
	WIDOWED = "WIDOWED",
}
